import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import StarDealPanel from 'Components/Carousel/FeaturedCarouselPanels/StarDealPanel';
import ProductPanel from 'Components/Carousel/FeaturedCarouselPanels/ProductPanel';
import BundlePanel from 'Components/Carousel/FeaturedCarouselPanels/BundlePanel';
import DefaultPanel from 'Components/Carousel/FeaturedCarouselPanels/DefaultPanel';
import CategorySalePanel from 'Components/Carousel/FeaturedCarouselPanels/CategorySalePanel';

const PanelSelector = ({ slide,
  siteTheme,
  slideClickFunction,
  slideExternalLink,
  slideUrl,
  switchCoverImg,
  fantasyVerse,
}) => {
  let PanelComponent = DefaultPanel;

  switch (slide.type) {
    case 'starDeal':
      PanelComponent = StarDealPanel;
      break;
    case 'bundle':
      PanelComponent = BundlePanel;
      break;
    case 'categorySale':
    case 'siteWideSale':
    case 'publisherSale':
    case 'franchiseSale':
      PanelComponent = CategorySalePanel;
      break;
    case 'preOrder':
    case 'flashDeal':
    case 'product':
      PanelComponent = ProductPanel;
      break;
    default:
      PanelComponent = DefaultPanel;
  }

  return (
    <PanelComponent
      hit={slide.hit}
      siteTheme={siteTheme}
      slide={slide}
      slideClickFunction={slideClickFunction}
      slideExternalLink={slideExternalLink}
      slideUrl={slideUrl}
      switchCoverImg={switchCoverImg}
      fantasyVerse={fantasyVerse}
    />
  );
};

PanelSelector.propTypes = {
  siteTheme: PropTypes.string,
  slide: PropTypes.shape({}),
  slideClickFunction: PropTypes.func,
  slideExternalLink: PropTypes.bool,
  slideUrl: PropTypes.string,
  starDeal: PropTypes.shape({}),
  switchCoverImg: PropTypes.func,
  fantasyVerse: PropTypes.bool,
};

PanelSelector.defaultProps = {
  siteTheme: 'dark',
  slide: {},
  slideClickFunction: () => {},
  slideExternalLink: false,
  slideUrl: '',
  starDeal: {},
  switchCoverImg: () => {},
  fantasyVerse: false,
};

const mapStateToProps = ({ siteTheme, starDeal }) => ({ siteTheme, starDeal });

export default connect(mapStateToProps)(PanelSelector);
